"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PACKAGE_VERSION = "4.0.0";
var _default = exports.default = PACKAGE_VERSION;
module.exports = exports.default;
//# sourceMappingURL=version.js.map